import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';

const loaderClasses = cva(
  'relative inline-block animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]',
  {
    variants: {
      size: {
        small: ['h-4', 'w-4'],
        medium: ['h-12', 'w-12'],
        large: ['h-16', 'w-16'],
      },
      color: {
        black: ['border-current'],
        white: ['border-white'],
      },
    },
    defaultVariants: {
      size: 'medium',
      color: 'black',
    },
  }
);

export type LoaderProps = VariantProps<typeof loaderClasses>;

export function Loader(props: LoaderProps) {
  const { size, color } = props;
  return (
    <div className='flex w-full items-center justify-center'>
      <div className={loaderClasses({ size, color })} role='status'></div>
    </div>
  );
}
